<template>
  <form class="flex flex-col justify-between font-sans-serif" @submit.prevent="cancelLesson">
    <div class="bg-background-academy text-center py-6 mb-4 text-white">
      <h1 class="w-full px-4
      font-bold tracking-widest uppercase text-lg mb-2">
        {{ $t('lesson.areYouSure') }}
      </h1>
      <h2 class="text-lg">
        {{ $t('lesson.irreversible') }}
      </h2>
      <h2 v-if="!forFree" class="text-md">
        {{ $t('lesson.terms') }}
      </h2>
    </div>
    <div class="px-20 pt-4 pb-6 mx-auto flex flex-col w-full">
      <label for="message" class="text-center pb-2">
        {{ $t('lesson.cancelMessage') }}
      </label>
      <textarea id="message" v-model="message" required class="border border-grey-academy-200" />
    </div>
    <div class="flex flex-row justify-between my-2 text-md uppercase w-1/2 mx-auto mb-10">
        <button
          @click.prevent="$emit('close')"
          class="mx-2 py-3 rounded border hover:bg-background-academy
          border-background-academy w-1/2 hover:text-white
          text-background-academy font-bold
          cursor-pointer md:w-full uppercase">
            {{ $t('lesson.cancel') }}
        </button>
        <button
          :class="isLoading ? 'loader' : ''"
          class="mx-2 py-3 rounded border w-1/2 hover:bg-background-academy
          border-background-academy hover:text-white
          text-background-academy font-bold
          cursor-pointer md:w-full uppercase">
            {{ $t('lesson.cancelLesson') }}
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  props: ['lesson', 'forFree'],

  data() {
    return {
      isLoading: false,

      message: '',
    };
  },

  computed: {
    ...mapGetters({
      student: ['auth/student'],
    }),
  },

  methods: {
    cancelLesson() {
      this.isLoading = true;
      axios.delete(`/api/lessons/${this.lesson.lesson_id}?for_free=${this.forFree}&message=${this.message}`)
        .then(() => {
          this.isLoading = false;
          this.$emit('close');
          this.createNotification('success', this.$t('lesson.cancelSuccess'));
          this.$router.go();
        }).catch(() => {
          this.createNotification('error', this.$t('notifications.errorTryAgain'));
        });
    },
  },
};
</script>
